import React, { useState } from "react";
import { motion } from "framer-motion";

export default function Form({ type = "contact" }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // Validation
  function validate() {
    const e = {};
    if (!form.name) e.name = "Required";
    if (!form.email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.email))
      e.email = "Valid email required";
    if (!form.phone || !/^[0-9]{7,15}$/.test(form.phone))
      e.phone = "Valid phone required";
    if (!form.message) e.message = "Required";
    setErrors(e);
    return Object.keys(e).length === 0;
  }

  // Submit handler (CONNECTED TO PHP)
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);

    const formData = new FormData();
    formData.append("name", form.name);
    formData.append("email", form.email);
    formData.append("phone", form.phone);
    formData.append("message", form.message);

    try {
      const res = await fetch(
        "https://tattvarealty.co.in/backend-files/encanto/contact-tattva.php", // 🔥 PHP file
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await res.json();

      if (data.status === "success") {
        window.location.href = "/thank-you"; // ✅ redirect
      } else {
        console.error("Submission failed:", data.message);
        setLoading(false);
      }
    } catch (err) {
      console.error("Error submitting form:", err);
      setLoading(false);
    }
  };

  return (
    <motion.form
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      onSubmit={handleSubmit}
    >
      {/* Name */}
      <div className="mb-3">
        <label className="form-label">Full Name</label>
        <input
          className={`form-control bg-transparent text-light ${
            errors.name ? "is-invalid" : ""
          }`}
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
        />
        <div className="invalid-feedback">{errors.name}</div>
      </div>

      {/* Email + Phone */}
      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label">Email</label>
          <input
            className={`form-control bg-transparent text-light ${
              errors.email ? "is-invalid" : ""
            }`}
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
          />
          <div className="invalid-feedback">{errors.email}</div>
        </div>

        <div className="col-md-6 mb-3">
          <label className="form-label">Phone</label>
          <input
            className={`form-control bg-transparent text-light ${
              errors.phone ? "is-invalid" : ""
            }`}
            value={form.phone}
            onChange={(e) => setForm({ ...form, phone: e.target.value })}
          />
          <div className="invalid-feedback">{errors.phone}</div>
        </div>
      </div>

      {/* Message */}
      <div className="mb-3">
        <label className="form-label">Message</label>
        <textarea
          rows={4}
          className={`form-control bg-transparent text-light ${
            errors.message ? "is-invalid" : ""
          }`}
          value={form.message}
          onChange={(e) => setForm({ ...form, message: e.target.value })}
        />
        <div className="invalid-feedback">{errors.message}</div>
      </div>

      {/* Buttons */}
      <div className="d-flex justify-content-end">
        <button
          type="button"
          className="btn btn-outline-light me-2"
          onClick={() =>
            setForm({ name: "", email: "", phone: "", message: "" })
          }
          disabled={loading}
        >
          Reset
        </button>

        <button className="btn btn-main" type="submit" disabled={loading}>
          {loading
            ? "Sending message..."
            : type === "popup"
            ? "Send Enquiry"
            : "Book Site Visit"}
        </button>
      </div>
    </motion.form>
  );
}
